import { FooterConfig } from '@tenants/types/tenant';

/**
 * Footer configuration for the AGNT Inc. investor-relations tenant.
 * Minimal IR-focused footer — matches the design at
 * https://anniewang-exp-exp-world-holdings.vercel.app/index.html
 */
export function createFooterConfig(): FooterConfig {
  return {
    footerColumns: {
      column1: [
        {
          label: { key: '', defaultValue: 'Why AGNT' },
          link: '/why-agnt',
          isAnchor: true,
          target: '_self',
        },
        {
          label: { key: '', defaultValue: 'News' },
          link: '/news',
          isAnchor: true,
          target: '_self',
        },
        {
          label: { key: '', defaultValue: 'Events & Presentations' },
          link: '/events-presentations',
          isAnchor: true,
          target: '_self',
        },
        {
          label: { key: '', defaultValue: 'Stock Information' },
          link: '/stock-information',
          isAnchor: true,
          target: '_self',
        },
      ],
      column2: [
        {
          label: { key: '', defaultValue: 'Financials' },
          link: '/financials',
          isAnchor: true,
          target: '_self',
        },
        {
          label: { key: '', defaultValue: 'Governance' },
          link: '/governance',
          isAnchor: true,
          target: '_self',
        },
        {
          label: { key: '', defaultValue: 'Resources' },
          link: '/resources',
          isAnchor: true,
          target: '_self',
        },
        {
          label: { key: '', defaultValue: 'Investor Alerts' },
          link: '/investor-alerts',
          isAnchor: true,
          target: '_self',
        },
      ],
      column3: [
        {
          label: { key: '', defaultValue: 'Privacy Policy' },
          link: '/privacy-policy',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: { key: '', defaultValue: 'Terms of Service' },
          link: '/terms-of-service',
          isAnchor: true,
          target: '_self',
        },
        {
          label: { key: '', defaultValue: 'Cookie Policy' },
          link: '/cookie-policy',
          isAnchor: false,
          target: '_blank',
        },
      ],
      bottom: [
        [
          {
            label: {
              key: '',
              defaultValue: `© ${new Date().getFullYear()} AGNT, Inc. All Rights Reserved.`,
            },
          },
        ],
      ],
      joinUsLink: '',
      footerImageData: null,
    },
    showAccessibilityLink: false,
  };
}
